// One owned card, explicit trusted playback, memory-only audio cache.
const MAX_BYTES = 8 * 1024 * 1024;
export function attachFlashcardSpeech(root, {page=document, windowTarget=window,
  fetcher=fetch, makeAudio=()=>new Audio(), urls=URL,
  csrf=page.querySelector('meta[name="csrf-token"]')?.content}={}) {
  if (root?.dataset.flashcardSpeechEnabled!=='true') return ()=>{};
  root.__tenantFlashcardSpeech?.();
  const id=root.dataset.flashcardId;
  const button=root.querySelector('.js-cartus-flashcard-speech');
  const status=root.querySelector('.cartus-flashcard-speech-status');
  if (!button || !status || (!/^[1-9][0-9]{0,18}$/.test(id || '') || (id.length===19 && id>'9223372036854775807')) || !csrf) return ()=>{};
  let audio, objectUrl, controller, timer, dead=false, busy=false, playing=false;
  const resetButton=()=>{button.removeAttribute('aria-busy');button.setAttribute('aria-pressed','false');playing=false;};
  function release() {
    controller?.abort();controller=null;clearTimeout(timer);timer=null;
    if(audio){audio.pause();audio.removeAttribute('src');audio.load();audio=null;}
    if(objectUrl){urls.revokeObjectURL(objectUrl);objectUrl=null;}
    resetButton();
  }
  async function click(event) {
    event.preventDefault();
    if (!event.isTrusted || dead || busy || root.dataset.flashcardId!==id) return;
    if(playing){audio.pause();audio.currentTime=0;resetButton();status.textContent='Audio stopped. Click to replay.';return;}
    busy=true;button.setAttribute('aria-busy','true');
    try {
      if(!objectUrl){
        status.textContent='Preparing pronunciation…';
        controller=new AbortController();const signal=controller.signal;
        timer=setTimeout(()=>controller?.abort(),30000);
        const response=await fetcher(`/langua/cartus_flashcards/${id}/audio`,{
          method:'POST',credentials:'same-origin',redirect:'error',cache:'no-store',signal,
          headers:{'Content-Type':'application/json','Accept':'audio/mpeg','X-CSRF-Token':csrf},body:'{}'
        });
        if(!response.ok || response.headers.get('content-type')?.split(';')[0]!=='audio/mpeg')throw Error();
        const declared=response.headers.get('content-length');
        if(declared&&(!/^\d+$/.test(declared)||Number(declared)>MAX_BYTES))throw Error();
        const reader=response.body.getReader(),chunks=[];let size=0;
        try {
          while(true){const {value,done}=await reader.read();if(done)break;
            size+=value.byteLength;if(size>MAX_BYTES||signal.aborted||dead)throw Error();chunks.push(value);}
        } finally {await reader.cancel();}
        if(size<16||(declared&&size!==Number(declared))||signal.aborted||dead)throw Error();
        const blob=new Blob(chunks,{type:'audio/mpeg'});
        const magic=new Uint8Array(await blob.slice(0,3).arrayBuffer());
        if(!((magic[0]===73&&magic[1]===68&&magic[2]===51)||(magic[0]===255&&(magic[1]&224)===224)))throw Error();
        if(dead||signal.aborted)throw Error();
        clearTimeout(timer);timer=null;controller=null;
        objectUrl=urls.createObjectURL(blob);audio=makeAudio();audio.src=objectUrl;
        audio.addEventListener('ended',()=>{if(!dead){resetButton();status.textContent='Click to replay pronunciation.';}});
        audio.addEventListener('error',()=>{if(!dead){release();status.textContent='Pronunciation unavailable. Please try again.';}});
      }
      if(dead) return;
      audio.currentTime=0;playing=true;button.setAttribute('aria-pressed','true');
      status.textContent='Playing pronunciation. Click again to stop.';await audio.play();
    }catch(_){release();if(!dead)status.textContent='Pronunciation unavailable. Please try again.';}
    finally{busy=false;button.removeAttribute('aria-busy');}
  }
  function destroy(){dead=true;release();button.removeEventListener('click',click);
    for(const name of ['turbolinks:before-cache','turbolinks:before-visit','turbo:before-cache'])page.removeEventListener(name,destroy);
    windowTarget.removeEventListener('pagehide',destroy);delete root.__tenantFlashcardSpeech;}
  button.addEventListener('click',click);
  for(const name of ['turbolinks:before-cache','turbolinks:before-visit','turbo:before-cache'])page.addEventListener(name,destroy);
  windowTarget.addEventListener('pagehide',destroy);root.__tenantFlashcardSpeech=destroy;return destroy;
}
